// extracted by mini-css-extract-plugin
module.exports = {"partnerCardWrap":"style_partnerCardWrap__8J_5R"};